import * as React from "react";
import { Component } from "react";
import styles from "../../../styles/flyouts/superadmin/unit_groups/Properties.scss";
import * as _ from "lodash";
import { withRouter } from "react-router";
import autobind from "autobind-decorator";
import {__, validateForm} from "../../../core/utils";
import { setNotification } from "../../../redux/actions/general/notification";
import { listUnitGroups, updateUnitGroup } from "../../../redux/actions/table/superadmin/unit_groups";
import EditUnitGroupForm from "../../../forms/superadmin/unit_groups/EditUnitGroupForm";

@withRouter
class Properties extends Component {
    @autobind
    _handleSubmit(formData) {
        return validateForm(
            updateUnitGroup(formData.id, _.omit(formData, ['id'])).then(() => {
                listUnitGroups();

                this.props.readAction(formData.id);

                setNotification(__('properties.notifications.properties-have-been-saved'));
            })
        );
    }

    render() {
        const { data } = this.props;

        return (
            <div className={styles.scroller}>
                <EditUnitGroupForm
                    onSubmit={this._handleSubmit}
                    initialValues={{
                        ..._.pick(data, ['id', 'name', 'priority']),
                    }}
                />
            </div>
        );
    }
}

export default Properties;
